export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "app/js/app.worker.1042a9a6ace99a3ddfbf.1793852707720.worker.js");
}
